export default __webpack_public_path__ + "static/media/inpost-size-b.74df723e.png";